module.exports = __webpack_public_path__ + "img/Currys--Logo@2x.225cc2cc.png";